var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 13.7672C45.9789 25.3988 36.0009 34.2331 24.0019 34.2331C12.0028 34.2331 2.02482 25.3988 -1.90735e-05 13.7672H6.35198C8.25684 21.9378 15.3888 28.0086 24.0019 28.0086C32.6149 28.0086 39.7431 21.9378 41.6517 13.7672H48Z",
    fill: "#223A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 13.7672C22.2659 13.7672 20.8598 15.1734 20.8598 16.9057C20.8598 18.6381 22.2659 20.0442 23.9983 20.0442C25.7307 20.0442 27.1368 18.6381 27.1368 16.9057C27.1368 15.1734 25.7307 13.7672 23.9983 13.7672Z",
    fill: "#223A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDl);
export default __webpack_public_path__ + "static/media/dl.bd601e9ca9cda639c2101e2540024a21.svg";
export { ForwardRef as ReactComponent };